import TransferSuccess from 'features/moveMoney/screens/transfer/TransferSuccess/TransferSuccess';
import React from 'react';

export default function TransferSuccessPage() {
  return <TransferSuccess />;
}
